import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";
import { spanish } from "./components/SpanishLocale";

const ReportsPage = lazy(() => import("./pages/ReportsPage/ReportsPage"));
const ReportEditorPage = lazy(() => import("./pages/ReportEditorPage/ReportEditorPage"));

export const reportsModule: FrontModule = {
  id: "reports",
  version: "0.2.0",
  permission: "reports.read",
  label: "Informes",
  icon: "file",
  description: "Elabora los informes de la organización a partir de plantillas y expórtalos a PDF y Word.",
  routes: [
    { path: "/reports", Component: spanish(ReportsPage) },
    { path: "/reports/:reportId", Component: spanish(ReportEditorPage) },
  ],
  menu: [
    {
      id: "reports.list",
      label: "Informes",
      icon: "file",
      path: "/reports",
      permission: "reports.read",
      description: "Los informes de la organización",
    },
  ],
};

export default reportsModule;
